module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAQdJREFUaEPtlkEKwlAMRCfncO1pvJJLr+RpXHuOLx/qpiD+ZCZIcf7mU0jSeTOFJnDwEwfXDwP8OkEn4ARIB/wJkQbS7U6AtpAc4ARIA+l2J0BbSA5wAqSBdPv/JDDGOAG40ZatDbhGxHOlNJXAGOMM4A5g3h3nAeASEfNeOimAObERIi1+6kkDNEGUxJcBxBBl8RSACIISTwOQELR4CUARQiJeBpCEkImXAixCSMXLAb5AyMW3AHyAaBHfBrCDmI+p9WBph9iKSn/i1Rdsawcyu83q7HddK0BWTKXeABXXlD1OQOlmZZYTqLim7HECSjcrs5xAxTVljxNQulmZ5QQqril7Dp/AC98+UDHLrXeLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/navigator/img/arrow-down-white.png
// module id = 922
// module chunks = 1